$('iframe').each(function() {
    var e = $(this).attr('src');

    if ($(this).attr('src').indexOf('?') > 0) {
        $(this).attr({
            src: e + '&wmode=transparent',
            wmode: 'Opaque'
        });
    } else {
        $(this).attr({
            src: e + '?wmode=transparent',
            wmode: 'Opaque'
        });
    }
});

$(function() {
    //responsive iframe handling
    if (!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode) {
        if ($('iframe').length > 0) {
            $('iframe').each(function() {
                var patternVideo = /(youtube\.com|youtu\.be|vimeo\.com)/,
                video = patternVideo.test($(this).attr('src')),
                patternIssuu = /(issuu\.com)/,
                issuu = patternIssuu.test($(this).attr('src')),
                iframeWidth = $(this).outerWidth(),
                iframeHeight = $(this).outerHeight(),
                iframePadding = iframeHeight / iframeWidth * 100;

                if (video) {
                    if ($(this).parent('.iframe-container').length === 0) {
                        $(this).wrap('<div class="iframe-container" />');
                    }

                    $(this).parent('.iframe-container').css('padding-bottom', iframePadding + '%');

                    if ($(this).attr('width')) {
                        if (!$(this).attr('width').match('%$')) {
                            $(this).parent('.iframe-container').wrap('<div class="iframe-container-wrapper" style="max-width:' + $(this).attr('width') + 'px"></div>');
                        }
                    }
                } else if (issuu) {
                    $(this).parent('.issuuembed').addClass('iframe-container').css('padding-bottom', iframePadding + '%');
                }
            });
        }
    }
});
